import { SellerCenterSSOApiClient } from '@/apis';

export default {
  async singleSignOn (payload) {
    return SellerCenterSSOApiClient.post('tex', payload, { hideSpinner: true });
  },
};
